import { DataTable, type DataTableColumn } from '../../_shared/DataTable';
import { useCampaignFormulas } from '../hooks/useCampaignFormulas';
import { NUMBER, PERCENT, CURRENCY } from '../../_shared/format';
import type { PerformanceCampaignFormulaRow } from '@/services/api';

export function CampaignFormulasTab({ campaignId }: { campaignId: string }) {
  const { data, loading } = useCampaignFormulas(campaignId, true);

  const columns: DataTableColumn<PerformanceCampaignFormulaRow>[] = [
    {
      key: 'formula',
      label: 'Formula',
      render: (row) => (
        <span className="text-navy-900" title={row.formula ?? ''}>
          {row.formula ?? <span className="text-slate-400">—</span>}
        </span>
      ),
    },
    {
      key: 'hook_type',
      label: 'Hook',
      width: '100px',
      render: (row) =>
        row.hook_type ? (
          <span className="rounded bg-indigo-100 px-1.5 py-0.5 text-[10px] font-mono text-indigo-700">
            {row.hook_type}
          </span>
        ) : null,
    },
    {
      key: 'tone',
      label: 'Tone',
      width: '100px',
      render: (row) =>
        row.tone ? (
          <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-mono text-slate-700">
            {row.tone}
          </span>
        ) : null,
    },
    {
      key: 'visual_style',
      label: 'Visual',
      width: '100px',
      render: (row) => row.visual_style ?? <span className="text-slate-400">—</span>,
    },
    {
      key: 'visitor_count',
      label: 'Visitors',
      align: 'right',
      width: '100px',
      render: (row) => NUMBER.format(row.visitor_count),
    },
    {
      key: 'atc_rate',
      label: 'ATC Rate',
      align: 'right',
      width: '100px',
      render: (row) => PERCENT(row.atc_rate * 100, 2),
    },
    {
      key: 'avg_persona_ltv',
      label: 'Avg LTV',
      align: 'right',
      width: '100px',
      render: (row) => CURRENCY.format(row.avg_persona_ltv),
    },
  ];

  return (
    <DataTable<PerformanceCampaignFormulaRow>
      columns={columns}
      rows={data?.rows ?? []}
      rowKey={(r) => `${r.formula ?? ''}_${r.hook_type ?? ''}_${r.tone ?? ''}`}
      loading={loading}
      emptyText="No creative formulas tracked for this campaign yet."
    />
  );
}
